import { useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  return useDataChange({
    context: 'selected',
    path: 'filters',
    viewPath: props.viewPath,
  })
}
